// Wrapper fino sobre las Cloud Functions de Value Score (equipamiento vs
// precio, normalizado por segmento) — Postgres/Neon.
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const obtenerRankingValueScoreFn = httpsCallable(functions, 'obtenerRankingValueScore');
const obtenerValueScoreDetalleFn = httpsCallable(functions, 'obtenerValueScoreDetalle');
const obtenerHistorialValueScoreFn = httpsCallable(functions, 'obtenerHistorialValueScore');
const simularValueScoreFn = httpsCallable(functions, 'simularValueScore', { timeout: 60000 });
const guardarPesosProyectoFn = httpsCallable(functions, 'guardarPesosProyecto');
const obtenerConfigValueScoreFn = httpsCallable(functions, 'obtenerConfigValueScore');
const guardarConfigValueScoreFn = httpsCallable(functions, 'guardarConfigValueScore');
const ejecutarValueScoresAhoraFn = httpsCallable(functions, 'ejecutarValueScoresAhora', { timeout: 300000 });

// { filas: [{vehicleVersionId, vehiculo, precio, scoreEquipamiento, valueScore, fuenteSpecs, posicion}], muestraInsuficiente, categoria }
export async function obtenerRankingValueScore(categoria) {
  const result = await obtenerRankingValueScoreFn({ categoria });
  return result.data;
}

// { score: {...} | null, promedioSegmento: {seguridad,tecnologia,motor,otros}, itemsFaltantesRelevantes: [{key,label,adopcionPct}] }
export async function obtenerValueScoreDetalle(vehicleVersionId) {
  const result = await obtenerValueScoreDetalleFn({ vehicleVersionId });
  return result.data;
}

// { historial: [{valueScore, scoreEquipamiento, fechaCalculo}] }
export async function obtenerHistorialValueScore(vehicleVersionId) {
  const result = await obtenerHistorialValueScoreFn({ vehicleVersionId });
  return result.data.historial;
}

// itemsAAgregar: array de keys de la taxonomía (ver detalle) a simular como agregados.
export async function simularValueScore(listaId, vehicleVersionId, { ajustePrecioPct, itemsAAgregar } = {}) {
  const result = await simularValueScoreFn({ listaId, vehicleVersionId, ajustePrecioPct, itemsAAgregar });
  return result.data;
}

export async function guardarPesosProyecto(listaId, pesos) {
  await guardarPesosProyectoFn({ listaId, ...pesos });
}

// Superadmin — pesos default globales (Mantenedor).
export async function obtenerConfigValueScore() {
  const result = await obtenerConfigValueScoreFn();
  return result.data.pesos;
}

export async function guardarConfigValueScore(pesos) {
  await guardarConfigValueScoreFn(pesos);
}

export async function ejecutarValueScoresAhora() {
  const result = await ejecutarValueScoresAhoraFn();
  return result.data;
}
